import * as yup from 'yup';

const safeReturnFormValidation = yup.object().shape({
  note: yup.object().shape({
    attachments: yup.array(),
    text: yup.string().when('attachments', {
      is: (attachments: any[]) => !attachments || attachments.length === 0,
      then: (schema) => schema.required('Note is required.'),
      otherwise: (schema) => schema,
    }),
  }),
});

export default safeReturnFormValidation;
